import React, { useState } from 'react'
import { Grid, makeStyles, Typography, IconButton, TextField } from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import Botao from "../../../shared/components/Botao";
import Logo from './Logo'
import ModalSelecaoLaboratorio from '../../../shared/components/ModalSelecaoLaboratorio'
import { autenticarLoginSenha, autenticarComLaboratorio as autenticarComLaboratorioDispatch } from '../LoginManager'
import { connect } from 'react-redux'
import { LIMITE_CHARS_USUARIO, LIMITE_CHARS_SENHA } from '../../../shared/utils/Constantes'

const LoginCustomizado = ({ autenticarComLaboratorio }) => {
    const classes = useStyles();

    const [usuario, setUsuario] = useState("");
    const [senha, setSenha] = useState("");
    const [erroUsuario, setErroUsuario] = useState(false);
    const [erroSenha, setErroSenha] = useState(false);
    const [carregando, setCarregando] = useState(false);
    const [carregandoModal, setCarregandoModal] = useState(false);
    const [modalSelecaoLaboratorioAberto, setModalSelecaoLaboratorioAberto] = useState(false);
    const [sessaoELaboratorios, setSessaoELaboratorios] = useState("");
    const [laboratorioSelecionado, setLaboratorioSelecionado] = useState([{}]);
    const [senhaVisivel, setSenhaVisivel] = useState(false);

    const handleClickBotaoEntrar = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        setCarregando(true);

        const resposta = await autenticarLoginSenha(usuario, senha);

        if (resposta) {
            setSessaoELaboratorios(resposta);
            if (resposta.convenios) {
                if (resposta.convenios.length === 1) {
                    setLaboratorioSelecionado(resposta.convenios[0]);
                    autenticar(resposta.convenios[0], resposta.idSessao);
                }
                else if (resposta.convenios.length > 1) {
                    setModalSelecaoLaboratorioAberto(true);
                }
            }
        }

        setCarregando(false);
    };

    const autenticar = async (laboratorio, idSessao) => {
        setCarregandoModal(true);
        await autenticarComLaboratorio
            (usuario, senha, laboratorioSelecionado.codigo || laboratorio.codigo, sessaoELaboratorios.idSessao || idSessao);
        setCarregandoModal(false);
    }

    const blur = (campo) => {
        if (campo === "usuario") {
            setErroUsuario(usuario === "");
        } else {
            setErroSenha(senha === "");
        }
    };

    const handleChangeUsuario = (event) => {
        if (event.target.value.length <= LIMITE_CHARS_USUARIO) {
            setUsuario(event.target.value);
        }
    }

    const handleChangeSenha = (event) => {
        if (event.target.value.length <= LIMITE_CHARS_SENHA) {
            setSenha(event.target.value);
        }
    }

    return (
        <>
            <ModalSelecaoLaboratorio
                setModalAberto={setModalSelecaoLaboratorioAberto}
                modalAberto={modalSelecaoLaboratorioAberto}
                opcoesLaboratorios={sessaoELaboratorios.convenios}
                laboratorio={laboratorioSelecionado}
                setLaboratorio={setLaboratorioSelecionado}
                handleClickBotaoModal={autenticar}
                carregandoModal={carregandoModal}
            />
            <Grid container justifyContent="center">
                <Grid item xs={12} sm={12} md={6} lg={4} className={classes.containerPagina} container>
                    <div className={classes.cabecalho} >
                        <Logo id='logo' className={classes.logo} />
                        <Typography variant="h5" className={classes.subtituloCabecalho}>Autenticação</Typography>
                    </div>

                    <form onSubmit={handleClickBotaoEntrar}>
                        <div className={`mb-2 ${classes.areaCampo}`}>
                            <TextField
                                className={classes.campo}
                                id='usuario'
                                placeholder='Usuário'
                                value={usuario}
                                error={erroUsuario}
                                InputLabelProps={{ shrink: false }}
                                onBlur={() => { blur('usuario') }}
                                onChange={handleChangeUsuario}
                                inputProps={{ autoCapitalize: 'none', autoCorrect: 'off' }}
                                helperText={erroUsuario ? 'Campo obrigatorio' : ''}
                                disabled={carregando}
                                variant='outlined'
                            />
                        </div>

                        <div className={`mb-5 ${classes.areaCampo}`}>
                            <TextField
                                className={classes.campo}
                                id='senha'
                                placeholder='Senha'
                                type={senhaVisivel ? 'text' : 'password'}
                                value={senha}
                                error={erroSenha}
                                InputLabelProps={{ shrink: false }}
                                onBlur={() => { blur('senha') }}
                                onChange={handleChangeSenha}
                                inputProps={{ autoCapitalize: 'off', autoCorrect: 'off' }}
                                helperText={erroSenha ? 'Campo obrigatorio' : ''}
                                disabled={carregando}
                                variant='outlined'
                                endAdornmentIcon={
                                    <IconButton className={classes.iconButton} onClick={() => setSenhaVisivel(!senhaVisivel)} aria-label='Search'>
                                        {senhaVisivel ?
                                            <VisibilityOffIcon /> :
                                            <VisibilityIcon />
                                        }
                                    </IconButton>
                                }
                            />
                        </div>
                    </form>

                    <Botao
                        titulo={"Entrar"}
                        className={classes.botaoEntrar}
                        target={'_self'}
                        type='primary'
                        uppercase={false}
                        fullWidth={true}
                        buttonType={'submit'}
                        carregando={carregando}
                        onClick={handleClickBotaoEntrar}
                        disabled={!usuario.length || !senha.length}
                    />

                    <Typography className={classes.textoRecuperacaoSenha} >
                        Caso queira recuperar ou redefenir sua senha, entre em contato com (31)4020-2175.
                    </Typography>
                </Grid>
            </Grid>
        </>
    )
}

const useStyles = makeStyles((theme) => ({
    containerPagina: {
        display: "flex",
        flexDirection: "column",
        border: "solid 1px #C0C0DE",
        borderRadius: "6px",
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(4),
        height: '90vh',
        margin: '5vh 0vh'
    },
    iconButton: {
        padding: '0px'
    },
    areaCampo: {
        height: '70px'
    },
    logo: {
        width: '192px'
    },
    cabecalho: {
        margin: '0 auto 24px',
        width: '206px',
        position: 'relative',
        textAlign: "center"
    },
    subtituloCabecalho: {
        paddingTop: theme.spacing(2),
        color: '#23144D',
        fontSize: '24px'
    },
    campo: {
        width: '100%'
    },
    botaoEntrar: {
        height: '56px',
        fontSize: '1rem'
    },
    textoRecuperacaoSenha: {
        paddingTop: theme.spacing(2),
        fontSize: '14px'
    }
}))

const mapStateToProps = state => {
    return {
        autenticado: state.login.usuarioAutenticado,
        acessoNegado: state.login.acessoNegado
    }
}

const mapDispatchToProps = {
    autenticarComLaboratorio: (usuario, senha, laboratorioSelecionado, idSessao) =>
        autenticarComLaboratorioDispatch(usuario, senha, laboratorioSelecionado, idSessao)
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginCustomizado)
